import styled from 'styled-components';

const StyledSideContent = styled.div`
    width: 100%;
    margin-right: 3.3rem;
`;

export { StyledSideContent };
